import React, { useContext } from "react";
import { useLazyQuery } from "@apollo/client";
import { useLocation, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import { GET_SERVICE_BY_ID } from "../../../graphql/queries/service.query";
import { AppButton, Breadcrumbs } from "../../../components";

import "./details.styles.css";
import { IonCol, IonRow } from "@ionic/react";
import { AuthContext } from "../../../context/AuthContext";
import { isPlatform } from "@ionic/core";

const Details = () => {
  const location: any = useLocation();
  const { addToCart } = useContext(AuthContext);

  const [serviceData, setServiceData] = React.useState<any>({});
  //@ts-ignore
  const { id } = useParams();

  const [getServiceById] = useLazyQuery(GET_SERVICE_BY_ID, {
    variables: {
      id: parseInt(id),
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      if (data) {
        setServiceData(data.getPublicServiceById.data);
      }
    },
  });

  React.useEffect(() => {
    getServiceById();
  }, []);

  const breadcrumbEntries = [
    { title: location?.state?.categoryName },
    { title: location?.state?.serviceName },
  ];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} backButton />

      <div className="app-page-wrapper app-page-wrapper-details">
        <IonRow>
          <IonCol sizeSm="12" sizeMd="12" sizeLg="5" sizeXs="12">
            <h1 className="details-title">{location?.state?.serviceName}</h1>

            <hr />

            <p className="details-paragraph">
              {serviceData && serviceData?.description}
            </p>
          </IonCol>

          <IonCol sizeSm="12" offset-lg="1" sizeMd="12" sizeLg="6" sizeXs="12">
            <h1 className="details-document-title">
              I documenti e le informazioni necessarie
            </h1>

            <hr />

            <ul className="service-details-list">
              {serviceData &&
                serviceData?.fields
                  ?.filter(
                    (field: any) => field.ioType === "input" && !field.isHidden
                  )
                  .map((field: any, index: number) => (
                    <li key={index}>
                      <span className="service-rounded-number">
                        {index + 1}
                      </span>
                      <span className="service-details-title ">
                        <span>
                          {field.cluster ? `${field.cluster} - ` : ""}
                        </span>
                        <span>{field.name}</span>
                      </span>
                    </li>
                  ))}
            </ul>

            <AppButton
              block
              buttonType="success"
              onClick={(e: any) => {
                e.persist();
                isPlatform("desktop")
                  ? //@ts-ignore
                    document.getElementById("cartRef").click()
                  : //@ts-ignore
                    document.getElementById("cartMobileRef").click();
                addToCart(serviceData.id, serviceData.name, uuidv4());
              }}
            >
              Aggiungi al carrello
            </AppButton>
          </IonCol>
        </IonRow>
      </div>
    </div>
  );
};

export default Details;
